import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  UrlTree,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AccountService } from 'src/app/components/account/account.service';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class CryptoGuard implements CanActivate {
  constructor(
    private accountService: AccountService,
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    if (this.authService.isCrypto()) {
      return this.checkAccess(state.url);
    }

    return true;
  }

  private checkAccess(currentUrl: string): boolean | UrlTree {
    const allowed = ['/cripto', '/wallet', '/account/view'].some(
      (p) => currentUrl === p || currentUrl.startsWith(p + '/')
    );

    return allowed ? true : this.router.parseUrl('/cripto');
  }
}
